const camelCaseCode = `import { camelCase } from 'cristatus';

const camelCaseString = camelCase("This is a string with multiple words"); //thisIsAStringWithMultipleWords
`;

export default camelCaseCode;
